import { api } from "@/api/axios.ts";
import {
  ApiWebhook,
  ApiWebhookFilter,
  ApiWebhookDelivery,
  ApiWebhookDeliveryFilter,
  ApiWebhookDeliveryPagedData,
  ApiWebhookPagedData,
  ApiWebhookSave,
  ApiWebhookUpdate,
  ApiWebhookWithSecret,
  ApiWebhookTestDeliveryResult,
} from "@/types/webhook.types.ts";

export const apiWebhook = {
  search: async function (payload: ApiWebhookFilter, signal?: AbortSignal) {
    return api.post<ApiWebhookPagedData>("/api/v1/webhooks/search", payload, signal);
  },
  getById: async function (id: number, signal?: AbortSignal) {
    return api.get<ApiWebhook>(`/api/v1/webhooks/${id}`, {}, signal);
  },
  create: async function (payload: ApiWebhookSave) {
    return api.post<ApiWebhookWithSecret>("/api/v1/webhooks", payload);
  },
  update: async function (id: number, payload: ApiWebhookUpdate) {
    return api.put<ApiWebhook>(`/api/v1/webhooks/${id}`, payload);
  },
  delete: async function (id: number) {
    return api.delete(`/api/v1/webhooks/${id}`);
  },
  rotateSecret: async function (id: number) {
    return api.post<ApiWebhookWithSecret>(`/api/v1/webhooks/${id}/rotate-secret`, {});
  },
  testDelivery: async function (id: number) {
    return api.post<ApiWebhookTestDeliveryResult>(`/api/v1/webhooks/${id}/test`, {});
  },
  searchDeliveries: async function (payload: ApiWebhookDeliveryFilter, signal?: AbortSignal) {
    return api.post<ApiWebhookDeliveryPagedData>(
      "/api/v1/webhooks/deliveries/search",
      payload,
      signal
    );
  },
  redeliver: async function (id: number) {
    return api.post<ApiWebhookDelivery>(`/api/v1/webhooks/deliveries/${id}/redeliver`, {});
  },
};
